import { render, staticRenderFns } from "./GroupListItem.vue?vue&type=template&id=0540d351&scoped=true"
import script from "./GroupListItem.vue?vue&type=script&lang=js"
export * from "./GroupListItem.vue?vue&type=script&lang=js"
import style0 from "./GroupListItem.vue?vue&type=style&index=0&id=0540d351&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0540d351",
  null
  
)

export default component.exports